import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { Routes_path } from "components/routerApp";

interface OrdineLavoroPageBreadcrumbsProps {
    ordineLavoroId?: number;
    codiceItem?: string;
}

const OrdineLavoroPageBreadcrumbs = ({
                                         ordineLavoroId,
                                         codiceItem,
                                     }: OrdineLavoroPageBreadcrumbsProps) => {
    return (
        <Breadcrumbs aria-label="breadcrumb">
            <Link
                to={Routes_path.HOME}
                style={{ textDecoration: "none", color: "inherit" }}
            >
                Home
            </Link>
            <Link
                to={Routes_path.ORDINI_LAVORO}
                style={{ textDecoration: "none", color: "inherit" }}
            >
                Ordini di Lavoro
            </Link>
            <Typography color="text.primary" fontWeight="bold">
                {codiceItem ? `#${ordineLavoroId} - ${codiceItem}` : `#${ordineLavoroId}`}
            </Typography>
        </Breadcrumbs>
    );
};

export default OrdineLavoroPageBreadcrumbs;